module.exports = __webpack_public_path__ + "static/media/_MIC2601.image.bddf41b7.png";